import { smsNotificationServiceEnvironment } from '../sms-notification-service-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { smsInviteStatusSchema } from '../schemas/sms-invite-status.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get the SMS status details for a list of assets
 * @param accountId Account Identifier
 * @param entityIds Array of External Identifiers for each Asset
 * @returns Array of SMS Invite Statuses
 */
export function postSmsNotificationStatusDetails(
  this: unknown,
  accountId: number,
  entityIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          smsNotificationServiceEnvironment.resolve(this)
            .smsNotificationStatusDetailsUrl
        }`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({ accountId, entityIds }),
        }
      )
    )
  ).pipe(selectData(z.array(smsInviteStatusSchema)));
}
